import * as OvationsApi from 'core/ovations-api';
import { RewardEventType, RewardStatus } from 'core/ovations-api/enums';
import { dateTimeCurrent } from 'core/util/datetime';

export const mockCardRewardDetailsList: OvationsApi.Types.CardRewardDetail[] = [
    {
        id: '1',
        status: OvationsApi.Enums.RewardStatus.Processed,
        amount: 30.0,
        fsvCardId: '100',
        cardNumber: '************-1234',
        replacements: 1,
        canRequestReplacement: true,
        canResendEmail: false,
        showCardServiceTool: false,
        replacementIsPending: false,
        updateDate: dateTimeCurrent(),
        history: [],
        undeliverableCount: 0,
        rewardPackageType: OvationsApi.Enums.RewardPackageType.SingleLoadUSA,
        rewardPackageName: 'RP1',
        retailerTitle: '',
    },
    {
        id: '2',
        status: OvationsApi.Enums.RewardStatus.Mailed,
        amount: 13.42,
        fsvCardId: '101',
        cardNumber: '************-5678',
        replacements: 2,
        updateDate: dateTimeCurrent(),
        canRequestReplacement: true,
        canResendEmail: false,
        showCardServiceTool: false,
        replacementIsPending: false,
        history: [],
        undeliverableCount: 0,
        rewardPackageType: OvationsApi.Enums.RewardPackageType.SingleLoadUSA,
        rewardPackageName: 'RP2',
        retailerTitle: '',
    },
    {
        id: '3',
        status: OvationsApi.Enums.RewardStatus.Replaced,
        amount: 13.42,
        fsvCardId: '102',
        cardNumber: '************-4321',
        replacements: 2,
        updateDate: dateTimeCurrent(),
        canRequestReplacement: false,
        canResendEmail: false,
        showCardServiceTool: false,
        replacementIsPending: false,
        history: [],
        undeliverableCount: 0,
        rewardPackageType: OvationsApi.Enums.RewardPackageType.SingleLoadUSA,
        rewardPackageName: 'RP3',
        retailerTitle: '',
    },
    {
        id: '4',
        status: OvationsApi.Enums.RewardStatus.Inactive,
        amount: 13.42,
        fsvCardId: '103',
        cardNumber: '************-9876',
        replacements: 2,
        updateDate: dateTimeCurrent(),
        canRequestReplacement: true,
        canResendEmail: false,
        showCardServiceTool: false,
        replacementIsPending: false,
        history: [],
        undeliverableCount: 0,
        rewardPackageType: OvationsApi.Enums.RewardPackageType.SingleLoadUSA,
        rewardPackageName: 'RP4',
        retailerTitle: '',
    },
    {
        id: '5',
        status: OvationsApi.Enums.RewardStatus.Activated,
        amount: 80.0,
        fsvCardId: '104',
        cardNumber: '************-1111',
        replacements: 2,
        updateDate: dateTimeCurrent(),
        canRequestReplacement: true,
        canResendEmail: false,
        showCardServiceTool: false,
        replacementIsPending: true,
        history: [],
        undeliverableCount: 0,
        rewardPackageType: OvationsApi.Enums.RewardPackageType.SingleLoadUSA,
        rewardPackageName: 'RP5',
        retailerTitle: '',
    },
    {
        id: '6',
        status: OvationsApi.Enums.RewardStatus.Deactivated,
        amount: 25.0,
        fsvCardId: '105',
        cardNumber: '************-2222',
        replacements: 2,
        updateDate: dateTimeCurrent(),
        canRequestReplacement: true,
        canResendEmail: false,
        showCardServiceTool: false,
        replacementIsPending: false,
        history: [],
        undeliverableCount: 0,
        rewardPackageType: OvationsApi.Enums.RewardPackageType.SingleLoadUSA,
        rewardPackageName: 'RP6',
        retailerTitle: '',
    },
    {
        id: '7',
        status: OvationsApi.Enums.RewardStatus.Expired,
        amount: 40.0,
        fsvCardId: '106',
        cardNumber: '************-3333',
        replacements: 2,
        updateDate: dateTimeCurrent(),
        canRequestReplacement: true,
        canResendEmail: false,
        showCardServiceTool: false,
        replacementIsPending: false,
        history: [],
        undeliverableCount: 0,
        rewardPackageType: OvationsApi.Enums.RewardPackageType.SingleLoadUSA,
        rewardPackageName: 'RP7',
        retailerTitle: '',
    },
    {
        id: '8',
        status: OvationsApi.Enums.RewardStatus.Undeliverable,
        amount: 40.0,
        fsvCardId: '106',
        cardNumber: '************-3333',
        replacements: 2,
        updateDate: dateTimeCurrent(),
        canRequestReplacement: true,
        canResendEmail: false,
        showCardServiceTool: false,
        replacementIsPending: false,
        history: [],
        undeliverableCount: 4,
        rewardPackageType: OvationsApi.Enums.RewardPackageType.SingleLoadUSA,
        rewardPackageName: 'RP8',
        retailerTitle: '',
    },
    {
        id: '9',
        status: OvationsApi.Enums.RewardStatus.Processed,
        amount: 30.0,
        fsvCardId: '100',
        cardNumber: '************-1234',
        replacements: 1,
        canRequestReplacement: true,
        canResendEmail: false,
        showCardServiceTool: false,
        replacementIsPending: false,
        updateDate: dateTimeCurrent(),
        history: [],
        undeliverableCount: 0,
        rewardPackageType: OvationsApi.Enums.RewardPackageType.SingleLoadUSAGalileo,
        rewardPackageName: 'RP9',
        retailerTitle: '',
    },
];

export const mockReloadableCardRewardDetailsList: OvationsApi.Types.CardRewardDetail[] = [
    {
        id: '8666d0a8-204c-4821-994f-f74da0547bb4',
        fsvCardId: '1000001774',
        cardNumber: '************-8773',
        amount: 20,
        status: OvationsApi.Enums.RewardStatus.Mailed,
        updateDate: '2018-10-01T00:00:00Z',
        canRequestReplacement: false,
        canResendEmail: false,
        showCardServiceTool: false,
        replacementIsPending: false,
        history: [
            {
                id: 0,
                status: RewardStatus.Processed,
                type: RewardEventType.Processed,
                date: '2018-09-27T17:27:52.494164Z',
            } as OvationsApi.Types.RewardProcessedEvent,
            {
                id: 1,
                oldStatus: RewardStatus.Processed,
                newStatus: RewardStatus.Activated,
                type: RewardEventType.StatusChanged,
                date: '2018-10-01T00:00:00Z',
            } as OvationsApi.Types.RewardStatusChangedEvent,
            {
                id: 2,
                oldStatus: RewardStatus.Activated,
                newStatus: RewardStatus.Mailed,
                type: RewardEventType.StatusChanged,
                date: '2018-10-01T00:00:00Z',
            } as OvationsApi.Types.RewardStatusChangedEvent,
            {
                id: 3,
                status: RewardStatus.Mailed,
                type: RewardEventType.Reloaded,
                amount: 20.0,
                date: '2018-10-27T17:27:52.494164Z',
            } as OvationsApi.Types.RewardReloadEvent,
            {
                id: 4,
                status: RewardStatus.Mailed,
                type: RewardEventType.Reloaded,
                amount: 30.0,
                date: '2018-11-27T17:27:52.494164Z',
            } as OvationsApi.Types.RewardReloadEvent,
        ],
        replacements: 0,
        undeliverableCount: 0,
        rewardPackageType: OvationsApi.Enums.RewardPackageType.ReloadableUSA,
        rewardPackageName: '',
        retailerTitle: '',
    },
];
